import type { VariantInfo, Campaign } from '~/modules/campaign/types';

import { useCGTemplateContext } from '~/modules/campaign-group-template/contexts/CGTemplateProvider';
import { useCampaignAnalyticContext } from '~/modules/campaign-analytics';
import { GButton, GStopPropagation } from '~/presentation/ui';
import { ChartVerticalIcon } from '@shopify/polaris-icons';
import { Badge, Box, InlineStack } from '@shopify/polaris';
import { ICampaignType } from '~/modules/campaign/types';
import { MakeWinnerButton } from '~/modules/make-winner';
import { useCampaignNavigate } from '~/modules/campaign';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface CGTemplatePairPropertyActionProps {
  variant: VariantInfo;
  campaign: Campaign;
}

export const CGTemplatePairPropertyAction: React.FC<CGTemplatePairPropertyActionProps> = ({
  campaign,
}) => {
  const { t } = useTranslation();
  const { onAnalyticsCampaign } = useCampaignNavigate();
  const { metrics } = useCampaignAnalyticContext();
  const { campaignGroup } = useCGTemplateContext();

  const isWinnerDeclared = useMemo(() => campaign.variants?.find((v) => !!v?.isWinner), [campaign]);

  const isCampaignDraft = useMemo(() => campaign.status === CAMPAIGN_STATUS.DRAFT, [campaign]);

  const handleOpenAnalytic = () => {
    if (isCampaignDraft) return;

    onAnalyticsCampaign({
      id: campaign.id,
      type: ICampaignType.TEMPLATE,
    });
  };

  const handleMakeWinner = () => {
    onAnalyticsCampaign(
      { id: campaign.id, type: ICampaignType.TEMPLATE },
      { params: { openMakeWinner: 'true' } },
    );
  };

  return (
    <GStopPropagation>
      <Box>
        {isWinnerDeclared ? (
          <Badge size="medium" tone="new" progress="complete">
            {t('Winner declared')}
          </Badge>
        ) : (
          <InlineStack gap="200" wrap={false}>
            <GButton
              icon={ChartVerticalIcon}
              disabled={isCampaignDraft}
              onClick={handleOpenAnalytic}
            ></GButton>
            <MakeWinnerButton
              campaign={campaign}
              metrics={metrics}
              goal={campaignGroup?.priority}
              onClick={handleMakeWinner}
            />
          </InlineStack>
        )}
      </Box>
    </GStopPropagation>
  );
};
